var friendsStore = {
    state: {
        friendList: []
    },
    mutations: {
        SET_FRIEND_LIST(state, { friendList }) {
            state.friendList = friendList;
        },
        UPDATE_FRIEND_PORTFOLIO_SHARING_DETAILS(state, { friendId, portfolioSharingDetails }) {
            const friend = state.friendList.find(friend => friend.id === friendId);
            if (friend) {
                friend.portfolioSharingDetails = portfolioSharingDetails;
            }
        }
    },
    actions: {
        setFriendList(context, { friendList }) {
            context.commit('SET_FRIEND_LIST', { friendList });
        },
        addFriend(context, { friend }) {
            const updatedList = [...context.state.friendList, friend];
            context.commit('SET_FRIEND_LIST', { friendList: updatedList });
        },
        removeFriend(context, { friendId }) {
            const updatedList = context.state.friendList.filter(friend => friend.id !== friendId);
            context.commit('SET_FRIEND_LIST', { friendList: updatedList });
        },
        updateFriendStatus(context, { friendId, status }) {
            const updatedList = context.state.friendList.map(friend => {
                if (friend.id === friendId) {
                    friend.status = status;
                }
                return friend;
            });
            context.commit('SET_FRIEND_LIST', { friendList: updatedList });
        },
        updateFriendPortfolioSharingDetails(context, { friendId, portfolioSharingDetails }) {
            context.commit('UPDATE_FRIEND_PORTFOLIO_SHARING_DETAILS', { friendId, portfolioSharingDetails });
        }
    },
    getters: {
        friendList(state) {
            return state.friendList;
        }
    }
}

export default friendsStore;